export const helpPageText = {
    NoHelpPage: {
        en: "No Help Page Found!",
        mr: "मदत पृष्ठ सापडले नाही!",
    },
    Message: {
        en: "There is no help page found in this program.",
        mr: "या कार्यक्रमात कोणतेही मदत पृष्ठ सापडले नाही.",
    },
    GoBack: {
        en: "Go back",
        mr: "परत जा",
    },
};
